/* BiorLabs PDP template scripts. Loaded only by biorlabs-* sections. */
(() => {
  if (window.__biorlabsLoaded) return;
  window.__biorlabsLoaded = true;

  const define = (name, cls) => {
    if (!customElements.get(name)) customElements.define(name, cls);
  };
  const lockScroll = (on) => document.documentElement.classList.toggle('bl-lock', on);
  const cartUrl = () => (window.routes && window.routes.cart_url) || '/cart';

  /* ---------- Header: sticky hide/show, countdown reveal, drawer, cart ---------- */
  define('bl-header', class extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.bl-hdr-bar');
      this.sticky = this.dataset.sticky !== 'false' && !!this.bar;
      this.cdMode = this.dataset.countdown || 'scroll';
      this.cd = this.querySelector('.bl-cd');
      this.fixed = false;
      this.lastY = window.scrollY;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();

      this.drawer = this.querySelector('.bl-drawer');
      this.querySelectorAll('[data-bl-open-drawer]').forEach((b) => b.addEventListener('click', () => this.toggleDrawer(true)));
      this.querySelectorAll('[data-bl-close-drawer]').forEach((b) => b.addEventListener('click', () => this.toggleDrawer(false)));
      this.onKey = (e) => { if (e.key === 'Escape') this.toggleDrawer(false); };
      document.addEventListener('keydown', this.onKey);

      this.cartLink = this.querySelector('[data-bl-cart]');
      if (this.cartLink) this.cartLink.addEventListener('click', (e) => this.openCart(e));
      this.bubble = this.querySelector('.bl-hdr__bubble');
      this.watchCart();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('keydown', this.onKey);
      if (this.cartObserver) this.cartObserver.disconnect();
      lockScroll(false);
    }
    // The header bar stays in the page at the top. Once scrolled past, it is pinned (position: fixed)
    // and slides in when scrolling up / out when scrolling down; this element keeps its height so
    // nothing below jumps. The countdown bar shows while the pinned header is visible.
    onScroll() {
      const y = window.scrollY;
      if (this.sticky) {
        const top = this.getBoundingClientRect().top + y;
        const natural = this.fixed ? this.naturalH : this.bar.offsetHeight;
        const delta = y - this.lastY;
        if (y <= top) {
          this.unfix();
        } else if (this.dataset.hide === 'false') {
          if (y > top) this.fix(true);
        } else if (delta < -2) {
          if (!this.fixed && y > top + natural) this.fix(false);
          if (this.fixed) this.bar.classList.add('is-shown');
        } else if (delta > 2 && this.fixed) {
          this.bar.classList.remove('is-shown');
        }
      }
      if (this.cd) {
        const pinnedVisible = this.fixed && this.bar.classList.contains('is-shown');
        const on = this.cdMode === 'always' || (this.cdMode === 'scroll' && (pinnedVisible || (!this.sticky && y > 150)));
        this.cd.classList.toggle('is-on', on);
      }
      this.lastY = y;
    }
    fix(showNow) {
      if (this.fixed) return;
      this.naturalH = this.bar.offsetHeight;
      this.style.minHeight = `${this.naturalH}px`;
      this.bar.classList.add('is-fixed');
      this.fixed = true;
      if (showNow) this.bar.classList.add('is-shown');
      else { this.bar.offsetHeight; this.bar.classList.add('is-shown'); }
    }
    unfix() {
      if (!this.fixed) return;
      this.bar.classList.remove('is-fixed', 'is-shown');
      this.style.minHeight = '';
      this.fixed = false;
    }
    toggleDrawer(open) {
      if (!this.drawer) return;
      if (!open && !this.drawer.classList.contains('is-open')) return;
      this.drawer.classList.toggle('is-open', open);
      this.drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      lockScroll(open);
    }
    openCart(e) {
      // Delegate to the theme's own cart icon so the cart drawer (or the cart app) opens exactly as on other pages.
      const themeIcon = document.querySelector('.shopify-section-group-header-group #cart-icon-bubble, #cart-icon-bubble:not([data-bl-cart])');
      if (themeIcon && themeIcon !== this.cartLink) {
        e.preventDefault();
        themeIcon.click();
        return;
      }
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        e.preventDefault();
        drawer.open(this.cartLink);
      }
    }
    setCount(n) {
      if (!this.bubble) return;
      const txt = n > 99 ? '99+' : String(n);
      if (this.bubble.dataset.count !== String(n)) this.bubble.dataset.count = String(n);
      if (this.bubble.textContent !== txt) this.bubble.textContent = txt;
    }
    // Fetch the cart count (used after our own add-to-cart and when coming back to the page).
    // Throttled so it can never turn into a stream of requests.
    refreshCount() {
      clearTimeout(this.countTimer);
      const wait = Math.max(250, 3000 - (Date.now() - (this.lastFetch || 0)));
      this.countTimer = setTimeout(() => {
        this.lastFetch = Date.now();
        fetch(`${cartUrl()}.js`, { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((c) => this.setCount(c.item_count || 0))
          .catch(() => {});
      }, wait);
    }
    // Mirror the theme's own (hidden) cart counter by reading it — no network request — so cart
    // apps that redraw that counter can't get into a loop with us.
    readThemeCount(themeIcon) {
      const bubble = themeIcon.querySelector('.cart-count-bubble');
      if (!bubble) return 0;
      const el = bubble.querySelector('span[aria-hidden="true"]') || bubble;
      const n = parseInt((el.textContent.match(/\d+/) || ['0'])[0], 10);
      return Number.isNaN(n) ? 0 : n;
    }
    watchCart() {
      const themeIcon = document.querySelector('#cart-icon-bubble');
      if (themeIcon && 'MutationObserver' in window) {
        this.cartObserver = new MutationObserver(() => this.setCount(this.readThemeCount(themeIcon)));
        this.cartObserver.observe(themeIcon, { childList: true, subtree: true, characterData: true });
      }
      if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => this.refreshCount()); } catch (err) { /* ignore */ }
      }
      document.addEventListener('bl:cart-updated', () => this.refreshCount());
      window.addEventListener('pageshow', (e) => { if (e.persisted) this.refreshCount(); });
    }
  });

  /* ---------- Countdown ---------- */
  define('bl-countdown', class extends HTMLElement {
    connectedCallback() {
      this.h = this.querySelector('[data-h]');
      this.m = this.querySelector('[data-m]');
      this.s = this.querySelector('[data-s]');
      this.end = this.getEnd();
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    getEnd() {
      const mode = this.dataset.mode || 'midnight';
      if (mode === 'evergreen') {
        const mins = parseInt(this.dataset.minutes || '120', 10);
        const key = `bl-cd-${this.dataset.key || 'x'}`;
        let end = 0;
        try { end = parseInt(sessionStorage.getItem(key) || '0', 10); } catch (e) { end = 0; }
        if (!end || end < Date.now()) {
          end = Date.now() + mins * 60000;
          try { sessionStorage.setItem(key, String(end)); } catch (e) { /* ignore */ }
        }
        return end;
      }
      const d = new Date();
      d.setHours(24, 0, 0, 0);
      return d.getTime();
    }
    tick() {
      let left = Math.max(0, this.end - Date.now());
      if (left === 0) { this.end = this.getEnd(); left = Math.max(0, this.end - Date.now()); }
      const t = Math.floor(left / 1000);
      const pad = (n) => String(n).padStart(2, '0');
      if (this.h) this.h.textContent = pad(Math.floor(t / 3600));
      if (this.m) this.m.textContent = pad(Math.floor((t % 3600) / 60));
      if (this.s) this.s.textContent = pad(t % 60);
    }
  });

  /* ---------- Product gallery ---------- */
  define('bl-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bl-gal__track');
      this.slides = [...this.querySelectorAll('.bl-gal__slide')];
      this.thumbs = [...this.querySelectorAll('.bl-gal__thumb')];
      this.tlist = this.querySelector('.bl-gal__tlist');
      this.index = 0;
      if (!this.track || !this.slides.length) return;
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
      this.querySelectorAll('[data-bl-thumb-prev]').forEach((b) => b.addEventListener('click', () => this.go(Math.max(0, this.index - 1))));
      this.querySelectorAll('[data-bl-thumb-next]').forEach((b) => b.addEventListener('click', () => this.go(Math.min(this.slides.length - 1, this.index + 1))));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => {
          const i = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
          if (i !== this.index) this.setActive(i);
        });
      }, { passive: true });
      this.slides.forEach((s) => {
        const v = s.querySelector('video');
        if (v) s.addEventListener('click', () => (v.paused ? v.play() : v.pause()));
      });
      if (this.tlist) this.tlist.scrollLeft = 0;
      // Load ahead: next slides start downloading after the page has loaded, and as soon as the
      // visitor touches the gallery, so swiping never lands on an empty slide.
      const ahead = () => { for (let k = 1; k <= 2; k++) this.warm(this.index + k); };
      const idle = (fn) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 2000 }) : setTimeout(fn, 800));
      const afterLoad = () => idle(() => { this.ready = true; ahead(); this.thumbs.forEach((t) => { const im = t.querySelector('img'); if (im) im.loading = 'eager'; }); });
      if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad, { once: true });
      ['touchstart', 'pointerdown', 'mouseenter'].forEach((ev) => this.addEventListener(ev, () => { this.ready = true; for (let k = 1; k <= 3; k++) this.warm(this.index + k); }, { passive: true }));
      this.setActive(0);
    }
    warm(i) {
      const s = this.slides[i];
      if (!s || s.dataset.warm) return;
      s.dataset.warm = '1';
      const img = s.querySelector('img');
      if (!img) return;
      if (s.dataset.ph && !img.complete) s.style.backgroundImage = `url("${s.dataset.ph}")`;
      if (img.loading === 'lazy') img.loading = 'eager';
      const decode = () => { if (img.decode) img.decode().catch(() => {}); };
      if (img.complete) decode(); else img.addEventListener('load', decode, { once: true });
    }
    go(i) {
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
      this.setActive(i);
    }
    setActive(i) {
      this.index = i;
      if (this.ready) { this.warm(i); this.warm(i + 1); this.warm(i + 2); this.warm(i - 1); }
      this.thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
      this.slides.forEach((s, k) => {
        const v = s.querySelector('video');
        if (v && k !== i) v.pause();
      });
      const t = this.thumbs[i];
      if (t && this.tlist) {
        const l = t.offsetLeft - this.tlist.offsetLeft;
        if (l < this.tlist.scrollLeft || l + t.offsetWidth > this.tlist.scrollLeft + this.tlist.clientWidth) {
          this.tlist.scrollTo({ left: l - this.tlist.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
        }
      }
      const prev = this.querySelector('[data-bl-thumb-prev]');
      const next = this.querySelector('[data-bl-thumb-next]');
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === this.slides.length - 1;
    }
  });

  /* ---------- Ships-by date ---------- */
  define('bl-shipdate', class extends HTMLElement {
    connectedCallback() {
      const days = parseInt(this.dataset.days || '1', 10);
      const skip = this.dataset.skipWeekends === 'true';
      const d = new Date();
      let added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        if (!skip || (d.getDay() !== 0 && d.getDay() !== 6)) added += 1;
      }
      if (skip) while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
      const lang = document.documentElement.lang || 'en';
      let txt;
      try { txt = d.toLocaleDateString(lang, { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) { txt = d.toDateString(); }
      this.textContent = txt;
    }
  });

  /* ---------- Price that follows the bundle selected in Kaching ---------- */
  // Kaching renders bars (.kaching-bundles__bar); the chosen one has --selected and shows its total
  // (.kaching-bundles__bar-price) and compare-at total (.kaching-bundles__bar-full-price) in the
  // visitor's currency. We copy those numbers into the price under the title.
  const parseMoney = (txt) => {
    let s = String(txt || '').replace(/[^\d.,]/g, '');
    if (!s) return NaN;
    const lastSep = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));
    if (lastSep > -1 && s.length - lastSep - 1 === 2) {
      s = s.slice(0, lastSep).replace(/[.,]/g, '') + '.' + s.slice(lastSep + 1);
    } else {
      s = s.replace(/[.,]/g, '');
    }
    return parseFloat(s);
  };
  define('bl-price', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-sync')) return;
      this.now = this.querySelector('[data-bl-now]');
      this.was = this.querySelector('[data-bl-was]');
      this.save = this.querySelector('[data-bl-save]');
      this.scope = this.closest('.bl-main') || document;
      this.update = this.update.bind(this);
      this.scope.addEventListener('change', this.update);
      this.scope.addEventListener('click', () => setTimeout(this.update, 0));
      this.observer = new MutationObserver(() => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(this.update);
      });
      this.observer.observe(this.scope.querySelector('.bl-app-block') || this.scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'checked'], characterData: true });
      this.update();
      // If Kaching never renders, show the normal product price.
      this.fallback = setTimeout(() => this.classList.add('is-synced'), 3000);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      clearTimeout(this.fallback);
    }
    update() {
      const bar = this.scope.querySelector('.kaching-bundles__bar--selected') ||
        (this.scope.querySelector('.kaching-bundles__bar input:checked') || {}).closest?.('.kaching-bundles__bar');
      if (!bar) return;
      const priceEl = bar.querySelector('.kaching-bundles__bar-price');
      const fullEl = bar.querySelector('.kaching-bundles__bar-full-price');
      const priceTxt = priceEl ? priceEl.textContent.trim() : '';
      if (!priceTxt) return;
      const fullTxt = fullEl ? fullEl.textContent.trim() : '';
      const price = parseMoney(priceTxt);
      const full = parseMoney(fullTxt);
      // Only touch the DOM when something actually changed, so other scripts watching the page
      // (Kaching, apps) never get a stream of no-op updates.
      if (this.now.textContent !== priceTxt) this.now.textContent = priceTxt;
      const hasCompare = !!(this.dataset.showCompare !== 'false' && fullTxt && full > price);
      if (this.was) {
        if (this.was.hidden !== !hasCompare) this.was.hidden = !hasCompare;
        if (hasCompare && this.was.textContent !== fullTxt) this.was.textContent = fullTxt;
      }
      if (this.save) {
        const tpl = this.save.dataset.template || '';
        const pct = hasCompare ? Math.round(((full - price) / full) * 100) : 0;
        const hide = !tpl || pct <= 0;
        if (this.save.hidden !== hide) this.save.hidden = hide;
        const txt = tpl.replace('[percent]', pct);
        if (pct > 0 && this.save.textContent !== txt) this.save.textContent = txt;
      }
      if (!this.classList.contains('is-synced')) this.classList.add('is-synced');
    }
  });

  /* ---------- Add-to-cart busy state ---------- */
  // Kaching disables the button while it adds the bundle; the theme adds .loading / shows its spinner.
  // Either way, show one centered spinner while busy. A sold-out button (data-unavailable) stays as is.
  define('bl-atc-state', class extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('.bl-atc');
      if (!this.btn) return;
      this.sync = () => {
        const busy = !this.btn.hasAttribute('data-unavailable') &&
          (this.btn.disabled || this.btn.classList.contains('loading') || this.btn.getAttribute('aria-disabled') === 'true');
        if (this.btn.classList.contains('bl-atc--busy') !== busy) this.btn.classList.toggle('bl-atc--busy', busy);
      };
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.btn, { attributes: true, attributeFilter: ['disabled', 'class', 'aria-disabled', 'data-unavailable'] });
      this.sync();
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
  });

  /* ---------- Faster add to cart: skip rendering the theme's hidden cart drawer ---------- */
  // Every add also asks Shopify to render the theme's own cart drawer (~40 KB, ~0.15 s of server time), but here
  // Kaching Cart replaces that drawer and keeps it display:none. Kaching tries to drop that render itself but doesn't
  // recognise this theme's drawer. Drop it only while it is provably unused — checked on every add: Kaching Cart is
  // on the page, the theme drawer is hidden, and it has no gift/upsell blocks (those read the fresh drawer HTML).
  // Otherwise the theme's normal list is returned. The small cart-icon section is always kept.
  const trimDrawerRender = (drawer) => {
    if (!drawer || drawer.__blTrimmed || typeof drawer.getSectionsToRender !== 'function') return;
    const original = drawer.getSectionsToRender;
    drawer.getSectionsToRender = function (...args) {
      const list = original.apply(this, args);
      const unused = Array.isArray(list) && !!window.kachingCartApi && !!document.querySelector('.kaching-cart') &&
        getComputedStyle(this).display === 'none' && !this.querySelector('cart-drawer-gift, cart-drawer-upsell');
      return unused ? list.filter((s) => s.id !== 'cart-drawer') : list;
    };
    drawer.__blTrimmed = true;
  };
  if (document.querySelector('.bl-main') && window.customElements) {
    customElements.whenDefined('cart-drawer').then(() => trimDrawerRender(document.querySelector('cart-drawer')));
  }

  /* ---------- Kaching "Buy once" link, shown below the trust icons ---------- */
  // Kaching's own button stays inside its widget (hidden by .bl-subs-moved) so Kaching keeps full control;
  // this button copies its text and look and forwards clicks to it. If Kaching drops the link, this hides too.
  define('bl-subs-link', class extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('.bl-subs__btn');
      this.scope = this.closest('.bl-main');
      if (!this.btn || !this.scope) return;
      this.btn.addEventListener('click', () => {
        const orig = this.orig();
        if (orig) orig.click();
      });
      this.sync = this.sync.bind(this);
      this.observer = new MutationObserver(() => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(this.sync);
      });
      const kaching = this.scope.querySelector('kaching-bundle');
      this.observer.observe((kaching && kaching.closest('.bl-app-block')) || this.scope, { subtree: true, childList: true, characterData: true });
      this.sync();
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      cancelAnimationFrame(this.raf);
    }
    orig() { return this.scope.querySelector('.kaching-bundles__subscriptions__link'); }
    sync() {
      const orig = this.orig();
      if (!orig) {
        if (!this.hidden) this.hidden = true;
        return;
      }
      const txt = orig.textContent.trim();
      if (this.btn.textContent !== txt) this.btn.textContent = txt;
      if (!this.styled) {
        const cs = getComputedStyle(orig);
        ['fontFamily', 'fontSize', 'fontWeight', 'letterSpacing', 'textTransform', 'color', 'textDecorationLine', 'textUnderlineOffset']
          .forEach((p) => { this.btn.style[p] = cs[p]; });
        this.styled = true;
      }
      if (this.hidden) this.hidden = false;
      if (!this.scope.classList.contains('bl-subs-moved')) this.scope.classList.add('bl-subs-moved');
    }
  });

  /* ---------- Visitor country (by IP) for the shipping line ---------- */
  define('bl-country', class extends HTMLElement {
    connectedCallback() {
      this.code = this.querySelector('[data-bl-cc]');
      this.flag = this.querySelector('[data-bl-flag]');
      let cached = null;
      try { cached = sessionStorage.getItem('bl-country'); } catch (e) { cached = null; }
      if (cached) { this.apply(cached); return; }
      const run = () => fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((d) => {
          const cc = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
          if (!cc) return;
          try { sessionStorage.setItem('bl-country', cc); } catch (e) { /* ignore */ }
          this.apply(cc);
        })
        .catch(() => {});
      if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 1500 }); else setTimeout(run, 300);
    }
    apply(cc) {
      if (!/^[A-Z]{2}$/.test(cc)) return;
      if (this.code && this.code.textContent !== cc) this.code.textContent = cc;
      if (this.flag) {
        const src = `https://flagcdn.com/w40/${cc.toLowerCase()}.png`;
        if (this.flag.getAttribute('src') !== src) { this.flag.style.display = ''; this.flag.src = src; }
      }
    }
  });

  /* ---------- Product videos ---------- */
  // Cards hold a small MP4 (data-src). Videos are created only when needed:
  // - row near the screen: first 3 videos fetch just their start (preload=metadata, small),
  // - finger/mouse down on a card: that video starts buffering before the tap completes,
  // - tap: play with sound.
  define('bl-videos', class extends HTMLElement {
    connectedCallback() {
      this.row = this.querySelector('.bl-vids__row');
      this.bar = this.querySelector('.bl-vids__bar');
      this.cards = [...this.querySelectorAll('.bl-vids__card')];
      this.cards.forEach((c) => {
        c.addEventListener('click', () => this.toggle(c));
        c.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.toggle(c); } });
        ['touchstart', 'pointerdown', 'mouseenter'].forEach((ev) => c.addEventListener(ev, () => this.prime(c, 'auto'), { passive: true }));
      });
      if ('IntersectionObserver' in window && this.row) {
        this.io = new IntersectionObserver((entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.io.disconnect();
          this.near = true;
          this.cards.forEach((c) => {
            this.resolve(c);
            const im = c.querySelector('img');
            if (im) im.loading = 'eager';
          });
          this.primeVisible();
        }, { rootMargin: '400px 0px' });
        this.io.observe(this.row);
      }
      if (this.row) {
        this.row.addEventListener('scroll', () => { this.progress(); if (this.near) this.primeVisible(); }, { passive: true });
        window.addEventListener('resize', () => this.progress(), { passive: true });
        this.progress();
      }
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
    // Shopify keeps 480p/720p/1080p MP4s next to each other; the HLS playlist (<id>.m3u8, ~1 KB)
    // lists their exact names. Read it once and switch to the wanted size.
    smallSrc(orig) {
      const want = this.dataset.quality || '480';
      const m = orig && orig.match(/\/videos\/c\/vp\/([0-9a-f]+)\/\1\.[A-Z]+-(\d+)p-[\d.]+Mbps-\d+\.mp4/);
      if (!m || m[2] === want) return Promise.resolve(orig);
      const base = orig.slice(0, orig.indexOf(m[1] + '/') + m[1].length + 1);
      return fetch(`${base}${m[1]}.m3u8`)
        .then((r) => (r.ok ? r.text() : ''))
        .then((txt) => {
          const v = txt.match(new RegExp(`${m[1]}\\.([A-Z]+)-${want}p\\.([\\d.]+)Mbps\\.hls\\.(\\d+)_\\.m3u8`));
          return v ? `${base}${m[1]}.${v[1]}-${want}p-${v[2]}Mbps-${v[3]}.mp4` : orig;
        })
        .catch(() => orig);
    }
    resolve(card) {
      if (!card.__src) card.__src = this.smallSrc(card.dataset.src);
      return card.__src;
    }
    // Give cards that are on screen (or about to slide in) a small head start.
    primeVisible() {
      if (!this.row) return;
      const r = this.row.getBoundingClientRect();
      this.cards.forEach((c) => {
        const b = c.getBoundingClientRect();
        if (b.left < r.right + b.width && b.right > r.left - b.width) this.prime(c, 'metadata');
      });
    }
    prime(card, preload) {
      let v = card.querySelector('video');
      if (!v) {
        const orig = card.dataset.src;
        if (!orig) return null;
        v = document.createElement('video');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        v.preload = preload;
        v.addEventListener('ended', () => card.classList.remove('is-playing'));
        v.addEventListener('error', () => { if (v.src && !v.src.endsWith(orig.replace(/^https?:/, ''))) { v.src = orig; if (card.classList.contains('is-playing')) v.play().catch(() => {}); } });
        card.insertBefore(v, card.querySelector('.bl-vids__btn'));
        v.__ready = this.resolve(card).then((src) => { v.src = src; return v; });
      } else if (preload === 'auto' && v.preload !== 'auto') {
        v.preload = 'auto';
      }
      return v;
    }
    toggle(card) {
      const v = this.prime(card, 'auto');
      if (!v) return;
      this.cards.forEach((c) => {
        const o = c.querySelector('video');
        if (o && o !== v && !o.paused) { o.pause(); c.classList.remove('is-playing'); }
      });
      if (!v.paused && v.muted) { v.muted = false; return; }
      if (v.paused) {
        v.muted = false;
        card.classList.add('is-playing');
        const start = () => {
          if (!card.classList.contains('is-playing')) return;
          const p = v.play();
          if (p && p.catch) p.catch(() => { v.muted = true; v.play().catch(() => {}); });
        };
        // Call play() inside the tap when the source is already known (keeps sound allowed on iOS);
        // otherwise as soon as the small file name is resolved.
        if (v.getAttribute('src')) start(); else (v.__ready || Promise.resolve()).then(start);
      } else {
        v.pause();
        card.classList.remove('is-playing');
      }
    }
    progress() {
      if (!this.row || !this.bar) return;
      const sw = this.row.scrollWidth || 1;
      const w = Math.min(100, (this.row.clientWidth / sw) * 100);
      this.bar.style.width = `${w}%`;
      this.bar.style.left = `${(this.row.scrollLeft / sw) * 100}%`;
    }
  });

  /* ---------- Upsell add-to-cart ---------- */
  define('bl-upsell', class extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-bl-upsell-add]');
      if (this.btn) this.btn.addEventListener('click', () => this.add());
    }
    async add() {
      const id = this.btn.dataset.variant;
      if (!id) return;
      this.btn.disabled = true;
      const drawer = document.querySelector('cart-drawer');
      let sections = ['cart-drawer', 'cart-icon-bubble'];
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        try { sections = drawer.getSectionsToRender().map((s) => s.id); } catch (e) { /* keep default */ }
      }
      try {
        const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections, sections_url: window.location.pathname }),
        });
        const json = await res.json();
        if (!res.ok || json.status) throw new Error(json.description || 'Error');
        document.dispatchEvent(new CustomEvent('bl:cart-updated'));
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ ...json, id: Number(id), sections: json.sections || {} });
        } else {
          window.location.href = cartUrl();
        }
      } catch (e) {
        window.location.href = cartUrl();
      } finally {
        this.btn.disabled = false;
      }
    }
  });

  /* ---------- Ingredients + popup slider ---------- */
  define('bl-ingredients', class extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('.bl-imod');
      this.track = this.querySelector('.bl-imod__track');
      this.slides = [...this.querySelectorAll('.bl-imod__slide')];
      this.cur = this.querySelector('[data-bl-cur]');
      this.prevBtn = this.querySelector('[data-bl-prev]');
      this.nextBtn = this.querySelector('[data-bl-next]');
      this.index = 0;
      this.querySelectorAll('[data-bl-open]').forEach((c) => {
        c.addEventListener('click', () => this.open(parseInt(c.dataset.blOpen, 10)));
      });
      if (!this.modal) return;
      this.querySelectorAll('[data-bl-close]').forEach((b) => b.addEventListener('click', (e) => { e.stopPropagation(); this.close(); }));
      if (this.prevBtn) this.prevBtn.addEventListener('click', (e) => { e.stopPropagation(); this.go(this.index - 1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', (e) => { e.stopPropagation(); this.go(this.index + 1); });
      this.slides.forEach((s, i) => s.addEventListener('click', (e) => { if (i !== this.index) { e.stopPropagation(); this.go(i); } }));
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal || e.target.classList.contains('bl-imod__vp') || e.target === this.track) this.close();
      });
      this.onKey = (e) => {
        if (!this.modal.classList.contains('is-open')) return;
        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowLeft') this.go(this.index - 1);
        if (e.key === 'ArrowRight') this.go(this.index + 1);
      };
      document.addEventListener('keydown', this.onKey);
      this.onResize = () => this.position(false);
      window.addEventListener('resize', this.onResize, { passive: true });
      this.bindSwipe();
    }
    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      window.removeEventListener('resize', this.onResize);
      lockScroll(false);
    }
    open(i) {
      if (!this.modal) return;
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      this.go(i, false);
      const c = this.slides[this.index] && this.slides[this.index].querySelector('.bl-imod__close');
      if (c) setTimeout(() => c.focus({ preventScroll: true }), 50);
    }
    close() {
      if (!this.modal) return;
      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
      lockScroll(false);
    }
    go(i, animate = true) {
      const n = this.slides.length;
      if (!n) return;
      this.index = Math.max(0, Math.min(n - 1, i));
      this.slides.forEach((s, k) => {
        s.classList.toggle('is-active', k === this.index);
        s.setAttribute('aria-hidden', k === this.index ? 'false' : 'true');
      });
      if (this.cur) this.cur.textContent = String(this.index + 1);
      if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.index === n - 1;
      this.position(animate);
    }
    position(animate) {
      const s = this.slides[0];
      if (!s || !this.track) return;
      const vp = this.track.parentElement.clientWidth;
      const w = s.offsetWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
      const x = (vp - w) / 2 - this.index * (w + gap);
      if (!animate) this.track.style.transition = 'none';
      this.track.style.transform = `translate3d(${x}px,0,0)`;
      if (!animate) { this.track.offsetHeight; this.track.style.transition = ''; }
    }
    bindSwipe() {
      let x0 = null;
      let y0 = null;
      this.track.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      this.track.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        const dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }
  });

  /* ---------- Generic horizontal slider (testimonials) ---------- */
  define('bl-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-bl-track]');
      if (!this.track) return;
      this.querySelectorAll('[data-bl-prev]').forEach((b) => b.addEventListener('click', () => this.step(-1)));
      this.querySelectorAll('[data-bl-next]').forEach((b) => b.addEventListener('click', () => this.step(1)));
      // Cards that sit off to the side never trigger the browser's lazy loading until swiped to,
      // so load all card images (and decode them) shortly before the section scrolls into view.
      const warm = () => {
        if (this.warmed) return;
        this.warmed = true;
        this.track.querySelectorAll('img').forEach((im) => {
          if (im.loading === 'lazy') im.loading = 'eager';
          const decode = () => { if (im.decode) im.decode().catch(() => {}); };
          if (im.complete) decode(); else im.addEventListener('load', decode, { once: true });
        });
      };
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) { this.io.disconnect(); warm(); }
        }, { rootMargin: '800px 0px' });
        this.io.observe(this);
      } else {
        warm();
      }
      ['touchstart', 'pointerdown'].forEach((ev) => this.track.addEventListener(ev, warm, { passive: true }));
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
    step(dir) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
      const w = card.getBoundingClientRect().width + gap;
      const max = this.track.scrollWidth - this.track.clientWidth;
      let left = this.track.scrollLeft + dir * w;
      if (dir > 0 && this.track.scrollLeft >= max - 4) left = 0;
      else if (dir < 0 && this.track.scrollLeft <= 4) left = max;
      this.track.scrollTo({ left, behavior: 'smooth' });
    }
  });

  /* ---------- Theme editor: open accordions / FAQ items when selected ---------- */
  document.addEventListener('shopify:block:select', (e) => {
    const el = e.target;
    if (!el || !el.closest || !el.closest('.bl')) return;
    if (el.tagName === 'DETAILS') el.open = true;
    const d = el.querySelector && el.querySelector('details');
    if (d) d.open = true;
  });
})();
